import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as UnsureSvg } from 'assets/unsure.svg';

const UnsureIcon: React.FC<SvgIconProps> = (props) => {
  return <SvgIcon {...props} component={UnsureSvg} />;
};

export default UnsureIcon;
